import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';

import FeedbackForm from './FeedbackForm';
import PartnersItem from './PartnerItem';
import { setFeedBackFormAction } from '../../../actions/setFeedBackFormAction';
import { validateFeedBackFormAction } from '../../../actions/validateFeedBackFormAction';
import { checkSubmitEventAction } from '../../../actions/checkSubmitEventActions';
import { clearStateAction } from '../../../actions/clearStateAction';
import axios from '../../../axios/axios';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class Partners extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            partner: [],
            participant: [],
            loading: false
        }

        this.bePartnerRef = React.createRef();
    }

    componentDidMount() {
        this.getPartners();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.key !== prevProps.location.key && this.props.location.hash === '#toBePartner') {
            window.scrollTo(0, this.bePartnerRef.current.offsetTop);
        }
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getPartners();
        }
      }

    getPartners = () => {
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        this.setState({...this.state, loading: true }, () => {
            axios.get(`/api/welsend/public/partners`)
            .then(res => {
                this.getArrayPartner(res.data);
                this.getArrayParticipant(res.data);
                this.scrollToBeParnter();
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    scrollToBeParnter = () => {
        if (this.props.location.state.toBePartner) {
            window.scrollTo(0, this.bePartnerRef.current.offsetTop);
        }
    }

    getArrayPartner(data) {
        const ukrPartners = data.filter(item => item.countryIso3 === 'UKR');
        const noUkrPartners = data.filter(item => item.countryIso3 !== 'UKR');
        const datas = [...ukrPartners, ...noUkrPartners]
        const partners = datas.filter(item => item.partnerType.name === 'Партнер');
        let partnerISO = [];
        const setISO = new Set();
        
        datas.forEach(item => {
            setISO.add(item.countryIso3)
        })

        partners.forEach(item => {
            const countryIso3 = item.countryIso3

            const listOfPartnerByISO = partners.filter(iso => iso.countryIso3 === countryIso3)

            const listOfPartner = {
                countryName: listOfPartnerByISO[0].countryName,
                countryIso3: listOfPartnerByISO[0].countryIso3,
                id: listOfPartnerByISO[0].id,
                list: listOfPartnerByISO
            }

            if (!partnerISO[countryIso3]) {
                partnerISO = {...partnerISO, [countryIso3]: listOfPartner}
            } 
        })
       
        const partnerItems = Array.from(setISO).map(value => {
            if (partnerISO[value]) {
                return <PartnersItem key={value} data={partnerISO[value]}
                                     defaultStaticContentPartners={this.props.defaultStaticContentPartners}
                                     activeLangStaticContentPartners={this.props.activeLangStaticContentPartners}/>
            }
         })
       
      this.setState({...this.state, partner: partnerItems, loading: false})
    }

    getArrayParticipant(data) {
        const ukrParticipant = data.filter(item => item.countryIso3 === 'UKR');
        const noUkrParticipant = data.filter(item => item.countryIso3 !== 'UKR');
        const datas = [...ukrParticipant, ...noUkrParticipant]
        const participants = datas.filter(item => item.partnerType.name === 'Учасник');
        let participantISO = [];
        const setISO = new Set();
        
        datas.forEach(item => {
            setISO.add(item.countryIso3)
        })

        participants.forEach(item => {
            const countryIso3 = item.countryIso3

            const listOfParticipantByISO = participants.filter(iso => iso.countryIso3 === countryIso3)

            const listOfParticipant = {
                countryName: listOfParticipantByISO[0].countryName,
                countryIso3: listOfParticipantByISO[0].countryIso3,
                id: listOfParticipantByISO[0].id,
                list: listOfParticipantByISO
            }

            if (!participantISO[countryIso3]) {
                participantISO = {...participantISO, [countryIso3]: listOfParticipant}
            } 
        })
       
        const participantItems = Array.from(setISO).map(value => {
            if (participantISO[value]) {
                return <PartnersItem key={value} data={participantISO[value]}
                                     defaultStaticContentPartners={this.props.defaultStaticContentPartners}
                                     activeLangStaticContentPartners={this.props.activeLangStaticContentPartners}/>
            }   
         })
       
      this.setState({...this.state, participant: participantItems})
    }

    render() {
        return(
            <div className="container partners">
               <h1>
                    {translateStaticContent('partnersHeading', 
                        this.props.defaultStaticContentPartners, this.props.activeLangStaticContentPartners)}
               </h1>
                 <p>
                    {translateStaticContent('partnersText', 
                        this.props.defaultStaticContentPartners, this.props.activeLangStaticContentPartners)}
                </p>
                <h2>
                    {translateStaticContent('partnersHeadingPartner', 
                        this.props.defaultStaticContentPartners, this.props.activeLangStaticContentPartners)}
                </h2>
                    {this.state.loading ? <Loader /> : 
                     <div>
                        {this.state.partner}
                        <h2>
                            {translateStaticContent('partnersHeadingParticipant', 
                                this.props.defaultStaticContentPartners, this.props.activeLangStaticContentPartners)}
                        </h2>
                        {this.state.participant}
                        <div className="feedBack" ref={this.bePartnerRef}>
                            <h2>
                                {translateStaticContent('feedBackHeading', 
                                    this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                            </h2>
                            <h3>
                                {translateStaticContent('feedBackSubHeading', 
                                    this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                            </h3>
                            <FeedbackForm 
                                setFeedBackForm={this.props.setFeedBackFormAction}
                                validateFeedBackForm={this.props.validateFeedBackFormAction} 
                                checkSubmitEvent={this.props.checkSubmitEventAction}
                                clearState={this.props.clearStateAction}
                                feedBackForm={this.props.feedBackForm}
                                defaultStaticContentFeedBack={this.props.defaultStaticContentFeedBack}
                                activeLangStaticContentFeedBack={this.props.activeLangStaticContentFeedBack}
                            />
                        </div>
                    </div> }
            </div> 
        )
    }
    
}

const mapStateToProps = store => {
    return {
      feedBackForm: store.feedBackForm,
      activeLang: store.lang.activeLang
    }
}
  
const mapDispatchToProps = dispatch => bindActionCreators({
    setFeedBackFormAction,
    validateFeedBackFormAction,
    checkSubmitEventAction,
    clearStateAction
}, dispatch)
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Partners);

Partners.propTypes = {
    setFeedBackForm: PropTypes.object,
    setFeedBackFormAction: PropTypes.func.isRequired,
    validateFeedBackFormAction: PropTypes.func.isRequired,
    checkSubmitEventAction: PropTypes.func.isRequired,
    clearStateAction: PropTypes.func.isRequired,
    feedBackForm: PropTypes.object.isRequired,
    location: PropTypes.object,
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentPartners: PropTypes.object,
    activeLangStaticContentPartners: PropTypes.object,
    defaultStaticContentFeedBack: PropTypes.object,
    activeLangStaticContentFeedBack: PropTypes.object,
}